export default function nl2br(text) {
    return text.split('\n').map((part, index) => index === 0 ? part : [<br />, part]);
}
